import React from 'react';
export function Footer() {
  return <footer className="bg-primary-dark text-white pt-16 pb-8" data-id="element-102" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-103" data-mp="3gfiuujlrgden">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-104" data-mp="3gh3qkcjta2e3">
          <div data-id="element-105" data-mp="32pfgsfx1bq0a">
            <h3 className="font-heading text-3xl font-bold mb-4 text-accent mt-[-10px]" data-id="element-106" data-mp="32lrkxa44arie">
              Dům u Sv. Václava
            </h3>
            <p className="max-w-xs text-[#8C8B7C]" data-id="element-107" data-mp="3ueik9th3kwbv">
              Nejmodernější ekologický bytový dům v ČR. 52 bytových jednotek,
              energetická soběstačnost, supermarket 24/7/365 a kavárna na střeše
              v obci Dolní Jirčany/Psáry.
            </p>
          </div>

          <div data-id="element-108" data-mp="3qdf393nbcu92">
            <h4 className="font-bold mb-4 text-accent uppercase tracking-wider text-sm" data-id="element-109" data-mp="3qcx9qes1cu4u">
              Rychlé odkazy
            </h4>
            <ul className="space-y-2 text-white/70" data-id="element-110" data-mp="29xlymixf0ugg">
              <li data-id="element-111" data-mp="2ey0akc250ojr">
                <a href="#o-projektu" className="hover:text-white transition-colors" data-id="element-112" data-mp="2eyjpdjwhqwtk">
                  O projektu
                </a>
              </li>
              <li data-id="element-113" data-mp="3gbio8wc31w3x">
                <a href="#galerie" className="hover:text-white transition-colors" data-id="element-114" data-mp="3gc0hdk3g7u7m">
                  Galerie
                </a>
              </li>
              <li data-id="element-115" data-mp="3q726ifxq4wa7">
                <a href="#vyhody" className="hover:text-white transition-colors" data-id="element-116" data-mp="3qaq0fg72zkpg">
                  Výhody
                </a>
              </li>
              <li data-id="element-117" data-mp="31uoff6267ob">
                <a href="#lokalita" className="hover:text-white transition-colors" data-id="element-118" data-mp="hstsqdzv2a23">
                  Lokalita
                </a>
              </li>
              <li data-id="element-119" data-mp="qti04pur1c60">
                <a href="#byty" className="hover:text-white transition-colors" data-id="element-120" data-mp="qsqd43f7wmrc">
                  Nabídka bytů
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-121" data-mp="tvcyrpppu1e3">
            <h4 className="font-bold mb-4 text-accent uppercase tracking-wider text-sm" data-id="element-122" data-mp="tvw66chqp7dv">
              Kontakt
            </h4>
            <ul className="space-y-2 text-white/70" data-id="element-123" data-mp="yuza1tlzh7k9">
              <li data-id="element-124" data-mp="13tkclzopk3bv">Projekt společnosti BRAMAL PROJECT s.r.o.</li>
              <li data-id="element-125" data-mp="13rzfq3ex88au">info@svatyvaclav.living</li>
              <li data-id="element-126" data-mp="18kiyrfwdnvn1">+420 602 304 915</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-white/50" data-id="element-127" data-mp="1clup5nn2skwa">
          <p data-id="element-128" data-mp="1hjnwik047ky5">© 2026 BRAMAL PROJECT s.r.o. Všechna práva vyhrazena.</p>
          <p className="mt-2 md:mt-0" data-id="element-129" data-mp="1mk1tn706hahe">Design pro Dům u Sv. Václava</p>
        </div>
      </div>
    </footer>;
}